"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _marqueePicture = _interopRequireDefault(require("../common/marquee-picture"));
var _image = require("@site/pattern-library-core/image");
var _marqueeVideo = _interopRequireDefault(require("../common/marquee-video.js"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _useElementProps = _interopRequireDefault(require("@site/pattern-library-utils/hooks/useElementProps"));
var _functions = require("../../../experiments/domain-search-marquee/functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-ccwykte"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hkdrmhi"
});
const MediaContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MediaContent",
  class: "pl-m1xlima7"
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageContainer",
  class: "pl-iefrn29"
});
const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pl-v15rhsyk"
});

/**
 * CategoryPageMarquee Component.
 * @module CategoryPageMarquee
 *
 * @param {Object} props React props
 * @param {String} props.layout Marquee Layout
 * @param {Object} props.portrait Mobile Image
 * @param {Object} props.tabletPortraitBackground Tablet Image
 * @param {Object} props.landscape Desktop Image
 * @param {Boolean} props.invert Invert Colors
 * @param {String} props.verticalPadding Vertical Inner Spacing
 * @param {String} props.partial Partial Theme
 * @param {String} props.introUrl Video URL
 * @param {String} props.introUrlWebm Video URL in WebM format
 * @param {String} props.introUrlLaptop Video URL for laptop
 * @param {String} props.introUrlLaptopWebm Video URL for laptop in WebM format
 * @param {Object} props.priceLockup Price Lockup
 * @returns {React.ReactElement} CategoryPageMarquee Component
 * @public
 */
// Helper function to determine if there's a video
const hasVideoContent = (introUrl, introUrlWebm, videos) => {
  return introUrl || introUrlWebm || videos && /*#__PURE__*/_react.default.isValidElement(videos);
};

// Helper function to render media content
const renderMediaContent = ({
  hasImage,
  hasVideo,
  layout,
  landscape,
  tabletPortraitBackground,
  portrait,
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  videos
}) => {
  return /*#__PURE__*/_react.default.createElement(MediaContent, {
    "data-layout": layout
  }, hasImage && /*#__PURE__*/_react.default.createElement(ImageContainer, {
    "data-layout": layout,
    className: hasVideo ? 'video-poster' : ''
  }, /*#__PURE__*/_react.default.createElement(_marqueePicture.default, {
    landscape: landscape,
    tabletPortraitBackground: tabletPortraitBackground,
    portrait: portrait,
    imgLoading: "eager"
  })), hasVideo && /*#__PURE__*/_react.default.createElement(VideoContainer, {
    className: "video-container"
  }, /*#__PURE__*/_react.default.createElement(_marqueeVideo.default, {
    introUrl: introUrl,
    introUrlWebm: introUrlWebm,
    introUrlLaptop: introUrlLaptop,
    introUrlLaptopWebm: introUrlLaptopWebm,
    thumbnailDesktop: landscape?.url,
    thumbnailMobile: portrait?.url,
    videos: videos
  })));
};
function CategoryPageMarquee({
  _name,
  layout = 'stacked',
  portrait,
  landscape,
  tabletPortraitBackground,
  invert = false,
  verticalPadding = 'small',
  partial,
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  videos,
  headline,
  priceLockup,
  ...headlineContent
}) {
  const hasImage = portrait?.url || landscape?.url;
  const hasVideo = hasVideoContent(introUrl, introUrlWebm, videos);
  const textAlign = (0, _functions.getTextAlign)(layout, headline);
  const disclaimerTooltip = headline?.props?.disclaimerTooltip || headline?.props?.tooltip;
  const processedPriceLockup = priceLockup || headline?.props?.priceLockup;
  const processedHeadlineLockup = (0, _useElementProps.default)(headline, {
    textAlign,
    fontType: 'text',
    headlineSize: headline?.props?.headlineSize || 'h1',
    invert: invert,
    disclaimerTooltip: disclaimerTooltip,
    priceLockup: processedPriceLockup
  });
  const lockup = /*#__PURE__*/(0, _react.isValidElement)(headline) ? processedHeadlineLockup : /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, headlineContent, {
    priceLockup: processedPriceLockup
  }));
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "category-marquee",
    padding: layout === 'stacked' ? 'none' : 'large',
    partial: partial || (invert ? 'dark1' : ''),
    verticalMargin: "none",
    verticalPadding: verticalPadding
  }, /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "container",
    "data-layout": layout
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-wrapper",
    "data-layout": layout
  }, lockup), renderMediaContent({
    hasImage,
    hasVideo,
    layout,
    landscape,
    tabletPortraitBackground,
    portrait,
    introUrl,
    introUrlWebm,
    introUrlLaptop,
    introUrlLaptopWebm,
    videos
  })));
}
var _default = exports.default = CategoryPageMarquee;
CategoryPageMarquee.propTypes = {
  _name: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['stacked', 'split', 'split-reverse']),
  portrait: _propTypes.default.shape(_image.imgPropShape),
  tabletPortraitBackground: _propTypes.default.shape(_image.imgPropShape),
  landscape: _propTypes.default.shape(_image.imgPropShape),
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  headline: _propTypes.default.oneOf(_propTypes.default.node, _propTypes.default.object),
  ..._patternLibraryUtils.paddingProps
};